import React, { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import useApi from "../../hooks/useApi";
import usePagination from "../../hooks/usePagination";
import useApp from "../../hooks/useApp";
import { CommissionPaidReport } from "./CommissionPaidReport";
import { CommissionInsurerReport } from "./CommissionInsurerReport";
import { CommissionBusinessReport } from "./CommissionBusinessReport";
import { RenewalNoticeReport } from "./RenewalNoticeReport";
import { ClientReport } from "./ClientReport";
import { ClientBusinessReport } from "./ClientBusinessReport";

function ReportDetail() {
  const { report = "" } = useParams();
  const { showAlert } = useApp();
  const { api, auth } = useApi();
  const navigate = useNavigate();

  const getReports = async () => {
    try {
      const url = `/reports`;
      const { data } = await api.list(url);
      return data;
    } catch (error) {
      throw new Error("failed to fetch records");
    }
  };

  const { data: reports } = useQuery(["reports", auth], ({ queryKey }) =>
    getReports()
  );

  let selectedReport = {};
  if (reports && report) {
    selectedReport = reports.find((ele) => ele.link === `/reports/${report}`);
  }

  const renderSelectedReport = (report) => {
    switch (report) {
      case "commission-paid":
        return <CommissionPaidReport />;
      case "commission-analysis-insurer":
        return <CommissionInsurerReport />;
      case "commission-analysis-business":
        return <CommissionBusinessReport />;
      case "renewal-notice":
        return <RenewalNoticeReport />;
      case "client":
        return <ClientReport />;
      case "client-business":
        return <ClientBusinessReport />;
      default:
        return "Report not found. Please try again";
    }
  };

  return (
    auth?.user && (
      <section id="content" className="content">
        <div className="content__header content__boxed overlapping">
          <div className="content__wrap">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item">
                  <a href="/reports">Reports</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  {selectedReport.name || ""}
                </li>
              </ol>
            </nav>
            <h1 className="page-title mb-2">{selectedReport.name || ""}</h1>
            <p>
              {selectedReport.info || ""}
              <br />
            </p>
          </div>
        </div>

        <div>
          <div className="content__boxed">
            <div className="content__wrap">{renderSelectedReport(report)}</div>
          </div>
        </div>
      </section>
    )
  );
}

export default ReportDetail;
